// NameComponent.tsx
import { VerifiedCheckIcon } from '@fingertip/icons'
import React, { CSSProperties, useMemo } from 'react'

import { TooltipWrapper } from '@/components/shared/tooltip-wrapper'

type Props = {
  name?: string | null
  className?: string
  style?: CSSProperties
  isPreview?: boolean
  hasVerifiedBadge?: boolean
}

export const HeaderName = ({
  name,
  className,
  style,
  isPreview,
  hasVerifiedBadge,
}: Props) => {
  const fallbackName = isPreview ? 'Your page name' : null
  const newName = name || fallbackName

  const containerClassName = `min-w-0 font-page-heading-weight font-page-heading text-fluid-4xl tracking-tight leading-[1.2] w-full ${className}`

  const size = useMemo(() => {
    if (className?.includes('text-fluid-5xl')) return 24
    if (className?.includes('text-fluid-4xl')) return 24
    if (className?.includes('text-fluid-3xl')) return 22
    if (className?.includes('text-fluid-2xl')) return 20
    if (className?.includes('text-fluid-xl')) return 18
    if (className?.includes('text-fluid')) return 16
    return 24
  }, [className])

  if (!newName) {
    return null
  }

  return (
    <div className={containerClassName} style={style}>
      <h1 className="break-words">
        {newName}
        {hasVerifiedBadge && (
          <TooltipWrapper message="This page has been verified by Fingertip">
            <div className="ml-[6px] inline-flex rounded-full text-blue-500">
              <VerifiedCheckIcon height={size} width={size} />
            </div>
          </TooltipWrapper>
        )}
      </h1>
    </div>
  )
}
